import {memoize} from '@servicenow/ui-internal';
import log from '../log';
import {addConsumer} from './consumers';
import {prefix} from './createContext';
import {getContext} from './contexts';

const shouldNotResolveContext = memoize(key => !key.toString().includes(prefix), {
	profileName: 'shouldNotResolveContext'
});

export default function createContextProxy(host) {
	return new Proxy(
		{},
		{
			get(target, prop) {
				if (shouldNotResolveContext(prop)) {
					if (process.env.NODE_ENV !== 'production') {
						log(
							`The context ${prop.toString()} could not be accessed. Context must be defined using the "createContext" function. "createContext" can imported from @servicenow/ui-core.`,
							{
								host: this,
								origin: 'createContextProxy'
							}
						);
					}

					return target[prop];
				}

				addConsumer(prop, host);
				return getContext(prop);
			},
			set(target, prop) {
				if (process.env.NODE_ENV !== 'production') {
					log(`Cannot set context value ${prop.toString()}. updateContext must be used.`, {
						host: this,
						origin: 'createContextProxy'
					});
				}
			}
		}
	);
}
